import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _ from 'lodash';
import axios from "axios/index";
import swal from 'sweetalert2';

import Header from '../../../Header/index';
import ProviderForm from './ProviderForm';
import urls from "../../../../utils/urls";
import ProgrammingForm from './ProgrammingForm';
import ReceptionForm from './ReceptionForm';
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import validators from "../../../../utils/validators";
import translator from "../../../../utils/translations";
import PageNotFound from '../../../../components/PageNotFound/pageNotFound';
import { Spinner } from '../../../../components/Loading/Spinner';
import helpers from '../../../../utils/helpers';
import TripSteps from '../Trip/TripSteps';


class NewTrip extends Component {

    constructor(props) {
        super(props);


        const {type} = this.props.match.params;

        let provider = '';
        if(helpers.isUserProvider(this.props.user)){
            provider = this.props.user.provider.id;
        }

        let buttons = helpers.getUserCreateButtons(this.props.user);
        let typeFound = false;

        buttons.forEach(b => {
           if(b.url === type){
               typeFound = true;
           }
        });

        this.state = {
            canUserCreateTrip: helpers.canUserCreateTrip(this.props.user) && typeFound,
            ajaxInProgress: false,
            providers: false,
            products: false,
            terminals: false,
            product: '',
            order_volume: '',
            trip_type: helpers.trip_type.FE,
            incoterm: type,
            terminal: '',
            provider: provider,
            line_number: '',
            st_number: '',
            st_company: '',
            carrier: '',
            carrier_doc: '',
            driver_name: '',
            driver_doc: '',
            estimated_load_date: '',
            load_datetime: '',
            truck_id: '',
            truck_plate: '',
            trailer_plate: '',
            provider_load_volume: '',
            provider_trip_receipt: '',
            provider_observations: ''
        }
    }

    componentDidMount() {
        this._fetchFiltersOptions();
    }

    _fetchFiltersOptions = () => {
        const provider = `${urls.API_ROOT}/api/v1/provider/`;
        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        axios.all([
            axios.get(provider, tokenHeader()),
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
        ])
            .then(axios.spread(function (prov, term, prod) {
                return {
                    providers: prov,
                    terminals: term,
                    products: prod
                }
            }))
            .then((data) => {
                this.setState({
                    providers: data.providers.data,
                    terminals: data.terminals.data,
                    products: data.products.data.filter(p => p.trip_type === 'FE')
                });
            })
            .catch((error) => ajaxHandler(error));
    };

    _handleInput = (prop, value) => {

        // Custom validations
        if(prop === 'carrier_doc'){
            value = value.replace(/-/g, '');
        }

        let numbers = ['line_number', 'order_volume', 'provider_load_volume'];
        if(numbers.indexOf(prop) > -1){
            value = validators.number(value);
        }

        this.setState({[prop]: value});
    };

    _handleDateChange = (prop, value) => {
        this.setState({[prop]: value });
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['providers', 'products', 'terminals', 'ajaxInProgress', 'canUserCreateTrip'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {
            if (data[key] === '') {
                data[key] = null;
            }
        });

        const NEW_SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/`;
        axios.post(`${NEW_SHIPMENT_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = (response) => {
        let trip = response.data;

        swal({
            title: 'Viaje creado',
            html: 'El viaje ingresado ha sido creado correctamente. Espere unos segundos mientras lo redirigimos',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(() => {
            this.props.history.push(`/trips/${trip.id}`);
        }, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido crear el viaje',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    _goBack = () => {

        let excludedKeys = ['providers', 'products', 'terminals', 'ajaxInProgress', 'canUserCreateTrip',
            'trip_type', 'incoterm'
        ];

        let data = _.omit(this.state, excludedKeys);
        let warning = false;
        Object.keys(data).forEach(key => {
            if (data[key] !== '') warning = true
        });

        if(warning){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/')
        }

    };

    render() {

        // Security check
        if(!this.props.user || !this.state.canUserCreateTrip){
            return <PageNotFound />;
        }

        // Waiting for options
        if(!(this.state.providers && this.state.products && this.state.terminals)){
            return (
                <div className={"main-dashboard"}>
                    <Header active={helpers.trip_type.FE} />
                    <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                        <Spinner />
                    </div>
                </div>

            );
        }

        let TripForm = ProgrammingForm;
        let steps = helpers.tripSteps.FOB;

        if(this.state.incoterm === 'CIF'){
            steps = helpers.tripSteps.CIF;
            if(helpers.isUserProvider(this.props.user)){
                TripForm = ProviderForm;
            }else{
                TripForm = ReceptionForm;
            }
        }

        return (
            <div className={"main-dashboard"}>
                <Header active={helpers.trip_type.FE} />
                <TripSteps steps={steps} currentStep={0} />
                <div className={"trip-section"}>
                    <div className={"trip-section-title"}>Información del viaje</div>
                    <TripForm
                        state={this.state}
                        user={this.props.user}
                        handleInput={this._handleInput}
                        handleDate={this._handleDateChange}
                        handleSelect={this._handleSelectChange}
                    />
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._goBack}
                                className={`btn btn-shell-empty z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Cancelar
                        </button>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}


const
    mapStateToProps = (state) => {
        return {
            user: state.user
        }
    };

const
    mapDispatchToProps = (dispatch) => {
        return bindActionCreators({}, dispatch);
    };

export default connect(mapStateToProps, mapDispatchToProps)(NewTrip);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/newTrip/index.js